import React from 'react'
import classNames from 'classnames'

import './Menu.scss'
import saucesImg from '../../assets/sauces.png'
// import lunchImg from '../../assets/lunch.png'
import MenuData from '../../datas/MenuData'

const uid = (length = 5) => {
  let text = ''
  const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

  for (let i = 0; i < length; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length))

  return text
}

class Item extends React.Component {
  render() {
    const { data } = this.props

    return (
      <div className="mb-3">
        <div className="d-flex justify-content-between">
          <div className="text-uppercase item-title">{data.title}</div>
          <div className="courier-new price text-nowrap">{data.price} €</div>
        </div>

        <div className="description">{data.description}</div>

        {data.description2 && <div className="description">{data.description2}</div>}
      </div>
    )
  }
}

const MenuDrink = ({ data, hide }) => {
  return (
    <div className={classNames({ hide })}>
      {data.sections.map(section => {
        return (
          <div key={`section-${section.sectionTitle}`} className="pr-0 pr-lg-5">
            <div className="mb-3">
              <span className="text-uppercase item-title">{section.sectionTitle}</span>
            </div>

            {section.items.map(item => {
              return <Item data={item} key={`item-${uid()}`} />
            })}

            <p>........................</p>
          </div>
        )
      })}
    </div>
  )
}

class MenuItem extends React.Component {
  render() {
    const { data, hide } = this.props

    return (
      <div className={classNames('pr-0 pr-lg-5 item-title', { hide })}>
        {data.items.map(item => {
          return <Item data={item} key={`item-${uid()}`} />
        })}

        {data.key === 'springrolls' && (
          <img className="sauces" src={saucesImg} alt="sauces pour rouleaux de printemps" />
        )}
      </div>
    )
  }
}

export default class Menu extends React.Component {
  state = {
    navigation: 'starters'
  }
  navigateTo = section => this.setState({ navigation: section })

  render() {
    const { navigation } = this.state

    return (
      <div className="menu-navigation">
        <div className="row no-gutters mb-4 section-navigation">
          <div className="col-12 mb-4 text-center d-flex justify-content-center justify-content-lg-start flex-wrap">
            {MenuData.map(section => {
              return (
                <div
                  className={classNames('section-title', { selected: navigation === section.key })}
                  key={`section-title-${section.key}`}
                  onClick={this.navigateTo.bind(this, section.key)}
                >
                  {section.title}
                </div>
              )
            })}
            {/* <div
              className={classNames('section-title', { selected: navigation === 'lunch' })}
              onClick={this.navigateTo.bind(this, 'lunch')}
            >
              Formules midi
            </div> */}
          </div>
        </div>

        <div className="row no-gutters">
          <div className="menu col-12 col-lg-5 col-xl-4">
            {MenuData.map(section => {
              if (section.key === 'drinks') {
                return (
                  <MenuDrink
                    data={section}
                    key="section-drinks"
                    hide={navigation !== section.key}
                  />
                )
              }

              return (
                <MenuItem
                  data={section}
                  key={`section-${section.key}`}
                  hide={navigation !== section.key}
                />
              )
            })}

            {/* <div className={classNames('pr-0 pr-lg-5', { hide: navigation !== 'lunch' })}>
              <p>Formules Disponibles du lundi au vendredi : ( hors jours fériés )</p>
              <img className={classNames('lunch-block')} src={lunchImg} alt="lunch menu midi" />
            </div> */}
          </div>

          <div
            className={classNames(
              `col-12 col-lg-7 col-xl-8 mt-4 mt-sm-0 img-navigation img-right ${navigation}`
            )}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Menu.js